import { ObjectSerializer } from "../DiscoveryEngine.TS/Serialization/ObjectSerializer";

export class DtoBase implements ObjectSerializer {

	constructor() {
		return;
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof DtoBase))
			return false;

		return true;
	}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		return;
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		return;
	}

}
